import { InputGroup as _InputGroup, InputGroupProps as _InputGroupProps } from "reactstrap";

    export const InputGroup = _InputGroup;
    export type InputGroupProps = _InputGroupProps;
    